<template>
  <div style="height: 100%; overflow-y: hidden">
    <div style="padding: 20px;">
      <van-button type="danger" round size="large" @click.stop="flashLogin">免注册一键登录</van-button>
    </div>
    <div style="padding: 10px">
      <p class="fl link" v-if="!is_dengbao" v-rblink.replace="{name:'loginByUsername'}">账号密码登录</p>
      <p class="link fr" v-rblink.replace="{name:'loginBySms'}">短信快捷登录</p>
    </div>
    <div class="cert-status login-success" :style="{top:success?'0px':'1000px'}">
      <div class="cert-status-content">
        <div class="cert-status-icon-success"></div>
        <p class="cert-status-title">{{ phone }}</p>
        <p class="cert-status-title">登陆成功</p>
      </div>
    </div>
  </div>
</template>

<style scoped="">
</style>
<script>
import {
  Cell, CellGroup, NoticeBar, Field, Button
} from 'vant';

export default {
  name: 'login',
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [NoticeBar.name]: NoticeBar,
    [Button.name]: Button, 
  },
  data: function () {
    return {
      formData: {
        nameOrPhone: '',
        password: '',
      },
      is_dengbao:true,
      phone: '',
      success: false,
      fileList: []
    }
  },
  created() {
  },
  mounted: function () {
    document.title = "用户登录";
    let that = this;
    // that.flashLogin()
    setTimeout(function () {
        that.flashLogin();
    },200)
    that.fetch();

  },
  methods: {
    fetch(){
        let that = this;
        that.$api.get('/api/index/logindetail', { 
        }, (res) => { 
            that.is_dengbao = res.data.is_dengbao;
        }, (res) => {
            // Toast.fail(res.msg);
        })
    },
    flashLogin() {
      var that = this;
      console.log('flashLogin');
      appEvent({
        name: 'flashLogin',
        query: {}
      });
    },


  }
}
</script>



// WEBPACK FOOTER //
// login.vue?a2934db4